import RelativePositionComponent from 'Component/Render/RelativePosition';
import Game from 'Game';
import { GameObjectEvent } from 'GameObject/GameObject';
import { FarmSharePopupLayout } from 'Layouts/Farm/FarmSharePopupLayout';
import { ContextType } from 'State/Game/ContextType';
import { GameActions } from 'State/Game/GameActions';
import { PopupID } from 'State/UI/PopupID';
import BaseUISystem from 'System/UI/BaseUISystem';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import Point from 'Utility/Point';
import BaseMenu from '../BaseMenu';
import { Layout } from 'Utility/layout/createLayout';
import { UIActions } from 'State/UI/UIActions';
import SpriteComponent from 'Component/Render/Sprite';
import TransformComponent from 'Component/Transform';

export default class FarmSharePopup extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.FARM_SHARE, uiSystem, false);
    }

    public onShow(params?: any) {
        this.layout = new FarmSharePopupLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        this.layout.baseImage.getComponent(SpriteComponent).texture = params.textureKey;
        this.layout.baseImage.getComponent(TransformComponent).height = 497;
        this.layout.baseImage.getComponent(TransformComponent).width = 882;

        this.layout.closeButton.on(GameObjectEvent.SELECTED, this.handleCloseClick);

        [this.layout.closeButton].forEach((button) => applyDefaultButtonAnimation(button));
    }

    public async preload() {
        Game.resource.add('myfarm_shareframe', 'resource/graphics/shares/farm/myfarm_shareframe.png');

        super.preload();
    }

    private readonly handleShare = (): void => {
        GameActions.setContext(ContextType.SHARE_FARM);
    };

    private readonly handleCloseClick = (): void => {
        UIActions.hidePopup(PopupID.FARM_SHARE);
    };
}
